import { getMessages } from '../../../../../../../store/constants';

export const GO_TO_GOOGLE_CALENDAR_HINT_TEXT= getMessages().getText('hint.go_to_google_calendar');
